$(() => {

    let currentURL;

    const teamPage = $('body.team'),
        companiesPopupTrigger = $('.companies-popup-trigger');

    // load content popup
    $(companiesPopupTrigger).on('click', function () {


        $('.posts-content-holder-section').html($(this).next().clone());
        $('.posts-content-holder-section').addClass('active');

        currentURL = window.location.href;
        let newURL = window.location.protocol+'//'+window.location.hostname+'/portfolio/'+$(this).attr('data-slug');

        window.history.replaceState(null, null, newURL);

        let companyContentPersonProfile = $('.posts-content-holder-section').find('.bs-row >.bs-column:nth-child(2) .bs-div--company-inner-key-person-profile-wrapper');

        let relatedPostsSectionInTeamInner = $('.posts-content-holder-section').find('.bs-section--team-inner-related-posts');
        if(relatedPostsSectionInTeamInner.length) {
          let pTag = relatedPostsSectionInTeamInner.find('> .container > .bs-row:nth-child(2) > .bs-column > p');
          if(pTag.html() == 'No articles found!') {
            relatedPostsSectionInTeamInner.hide();
          } else {
            relatedPostsSectionInTeamInner.show();
          }
        }

        $('body').css('overflow', 'hidden');
        setTimeout(() => {
            let contentWrapperInner = $('.posts-content-holder-section').find('.post__content-wrapper--inner');
            contentWrapperInner.addClass('open');

            if (window.innerWidth < 768) {
                if (companyContentPersonProfile.length > 0) {
                    companyContentPersonProfile.closest('.bs-row').find('>.bs-column:first-child').prepend(companyContentPersonProfile);
                }
            }

        }, 300);
    });

    // close content popup
    $(window).on('click', function (elem) {
        if (teamPage.length > 0) {
            if ($(elem.target).attr('class') == "post__content-wrapper--right" || $(elem.target).attr('class') == "post__content-wrapper--close") {
                $('.posts-content-holder-section').find('.post__content-wrapper--inner').removeClass('open');

                let companyContentPersonProfile = $('.posts-content-holder-section').find('.bs-row >.bs-column:first-child .bs-div--company-inner-key-person-profile-wrapper');

                setTimeout(() => {
                    $('.posts-content-holder-section').removeClass('active');
                    $('body').css('overflow', 'auto');

                    window.history.replaceState(null, null, currentURL);


                    if (window.innerWidth < 768) {
                        if (companyContentPersonProfile.length > 0) {
                            companyContentPersonProfile.closest('.bs-row').find('>.bs-column:nth-child(2)').prepend(companyContentPersonProfile);
                        }
                    }
                    setTimeout(() => {
                        $('.posts-content-holder-section .post__content-wrapper').remove();
                    }, 150);
                }, 300);
            }
        }
    });

    $(window).on('resize', () => {
        if (window.innerWidth < 768) {
            let companyContentPersonProfileOnRight = $('.posts-content-holder-section').find('.bs-row >.bs-column:nth-child(2) .bs-div--company-inner-key-person-profile-wrapper');

            if (companyContentPersonProfileOnRight.length > 0) {
                companyContentPersonProfileOnRight.closest('.bs-row').find('>.bs-column:first-child').prepend(companyContentPersonProfileOnRight);
            }
        } else {
            let companyContentPersonProfileOnLeft = $('.posts-content-holder-section').find('.bs-row >.bs-column:first-child .bs-div--company-inner-key-person-profile-wrapper');

            if (companyContentPersonProfileOnLeft.length > 0) {
                companyContentPersonProfileOnLeft.closest('.bs-row').find('>.bs-column:nth-child(2)').prepend(companyContentPersonProfileOnLeft);
            }
        }
    });

});